
export default class Ajax
{
    public static get(url: string): Promise<string>
    {
        let xmlHttp = new XMLHttpRequest();

        return new Promise<string>((resolve, reject) =>
        {
            xmlHttp.onreadystatechange = () =>
            {
                if(xmlHttp.readyState == 4)
                {
                    if (xmlHttp.status == 200)
                    {
                        return resolve(xmlHttp.responseText);
                    }
                    else
                    {
                        return reject(new Error(xmlHttp.statusText));
                    }
                }
                else
                {
                    return;
                }
            }
            
            xmlHttp.open('get', url); 
            xmlHttp.send();
        });
    }
}